import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { usePostRequest } from '@/hooks';
import { FormData, getBusinessTypeKorean } from '../types';
import { getInitialFormData } from '../utils/validation';
import { ClickEventName, track } from '@/track';
import { getAccessToken } from '@/auth';

export const useContactForm = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid }
  } = useForm<FormData>({
    defaultValues: getInitialFormData(),
    mode: 'onChange'
  });

  const { trigger, isLoading, error } =
    usePostRequest<CommonResponseModel<Record<string, never>>>('/api/plans/inquiries');

  const [successResponse, setSuccessResponse] = useState<CommonResponseModel<
    Record<string, never>
  > | null>(null);

  const onSubmit = handleSubmit(async (data: FormData) => {
    try {
      const accessToken = await getAccessToken();
      const params = {
        business_name: data.organizationName,
        business_type: getBusinessTypeKorean(data.businessType),
        use_months: data.useMonths,
        payment_preference: data.paymentMethod,
        is_logged_in: accessToken ? 'true' : 'false'
      };

      track.onClick({ clickEventName: ClickEventName.click_plan_enterprise_form_submit, params });
      // trigger는 성공 시 응답 데이터를 반환합니다
      const response = await trigger(data);

      if (response) {
        setSuccessResponse(response);
      }
    } catch (error) {
      // 에러 발생 시 catch 블록 실행
      // 에러는 이미 전역 토스트로 표시됨 (api.ts의 interceptorResponse)
      console.error('Submit error:', error);
    }
  });

  useEffect(() => {
    if (successResponse) {
      setIsSubmitted(true);
    }
  }, [successResponse]);

  return {
    control,
    register,
    handleSubmit: onSubmit,
    watch,
    errors,
    isValid,
    isSubmitted,
    isLoading,
    error
  };
};
